import {
  Calendar,
  Home,
  Heart,
  Cake,
  GraduationCap,
  PartyPopper,
  Shield,
  AlertTriangle,
  Zap,
  Laugh,
  Music,
  Film,
  Gamepad2,
  Users,
  BookText,
  HelpCircle,
  Smile,
  Paintbrush,
  UserCheck,
  Beer,
} from "lucide-react";

export const modes = [
  {
    id: "classic",
    name: "Prawda czy Wyzwanie",
    description:
      "Odpowiadaj na pytania lub wykonuj zadania. Wybór należy do Ciebie!",
    icon: HelpCircle,
    types: ["pytanie", "wyzwanie"], // Typy zadań używane w tym trybie
  },
  {
    id: "never_have_i_ever",
    name: "Nigdy Przenigdy",
    description:
      "Dowiedz się, czego próbowali Twoi znajomi. Kto pije tym razem?",
    icon: Beer,
    types: ["nigdy_przenigdy"],
  },
  {
    id: "who_is_most_likely",
    name: "Wskaż Osobę",
    description: "Kto z Was pasuje do opisu? Głosujcie i sprawdźcie!",
    icon: Users,
    types: ["wskaz_osobe"],
  },
];

export const difficulties = [
  {
    level: 1,
    name: "Łagodny",
    description: "Proste pytania i łatwe wyzwania",
    color: "text-green-400",
  },
  {
    level: 2,
    name: "Średni",
    description: "Dla odważniejszych",
    color: "text-orange-400",
  },
  {
    level: 3,
    name: "Ekstremalny",
    description: "Tylko dla najodważniejszych",
    color: "text-purple-400",
  },
];

export const nsfwOptions = [
  {
    id: false, // Wartość dla state.settings.nsfwEnabled
    name: "Rodzinnie",
    description: "Bez treści dla dorosłych.",
    icon: Shield,
    // Style, gdy opcja jest wybrana
    selectedClasses:
      "bg-green-600/20 border-green-400/70 ring-2 ring-green-400",
    selectedIconClasses: "text-green-300",
    selectedTextClasses: "text-green-100",
    checkmarkBg: "bg-green-500 border-green-800/50",
  },
  {
    id: true, // Wartość dla state.settings.nsfwEnabled
    name: "18+",
    description: "Uwzględnij treści tylko dla dorosłych.",
    icon: AlertTriangle,
    // Style, gdy opcja jest wybrana
    selectedClasses: "bg-red-600/20 border-red-400/70 ring-2 ring-red-400",
    selectedIconClasses: "text-red-300",
    selectedTextClasses: "text-red-100",
    checkmarkBg: "bg-red-500 border-red-800/50",
  },
];

export const occasions = [
  { id: "domowka", name: "Domówka", icon: Home },
  { id: "panienski", name: "Panieński", icon: Heart },
  { id: "kawalerski", name: "Kawalerski", icon: PartyPopper },
  { id: "urodziny", name: "Urodziny", icon: Cake },
  { id: "studencka", name: "Impreza", icon: GraduationCap },
  { id: "ogolna", name: "Ogólna", icon: Calendar },
];

export const themes = [
  {
    id: "ogolne",
    name: "Ogólne",
    icon: Zap,
    description: "Uniwersalne pytania i wyzwania",
  },
  {
    id: "milosc",
    name: "Miłość i związki",
    icon: Heart,
    description: "Pytania o uczucia i relacje",
  },
  {
    id: "humor",
    name: "Humor",
    icon: Laugh,
    description: "Zabawne i śmieszne wyzwania",
  },
  {
    id: "muzyka",
    name: "Muzyka",
    icon: Music,
    description: "Śpiewanie, taniec i muzyka",
  },
  {
    id: "filmy",
    name: "Filmy i seriale",
    icon: Film,
    description: "Cytaty, aktorstwo, sceny",
  },
  {
    id: "gry",
    name: "Gry i sport",
    icon: Gamepad2,
    description: "Aktywność fizyczna i gry",
  },
];

export const suggestedNames = ["Anna", "Kasia", "Tomek", "Michał", "Ola"];

export const getDifficultyStyle = (difficulty) => {
  const styles = {
    1: {
      text: "text-green-300",
      border: "border-green-500",
      bg: "bg-green-600/20",
    },
    2: {
      text: "text-orange-300",
      border: "border-orange-500",
      bg: "bg-orange-600/20",
    },
    3: {
      text: "text-purple-300",
      border: "border-purple-500",
      bg: "bg-purple-600/20",
    },
  };
  return (
    styles[difficulty] || {
      text: "text-gray-300",
      border: "border-gray-500",
      bg: "bg-gray-600/20",
    }
  );
};
